import { useAuth } from '@/context/AuthProvider';
import { useState } from 'react';
import { Link } from 'react-router';
import { Alert, Box, Button, Flex, Input, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import PasswordInput from '@/components/PasswordInput';

function LoginScreen() {
  const { login } = useAuth();
  const { t } = useTranslation('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isPending, setIsPending] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setIsPending(true);

    try {
      await login(email, password);
    } catch {
      setError(t('invalidCredentials'));
    } finally {
      setIsPending(false);
    }
  };

  return (
    <Flex minH="100vh" align="center" justify="center" bg="gray.50" px={4}>
      <Box bg="white" p={8} rounded="lg" shadow="md" w="full" maxW="400px">
        <Flex direction="column" align="center" mb={6}>
          <img src="/sindi-black.svg" alt="Sindi" style={{ height: '40px' }} />
        </Flex>

        <form onSubmit={onSubmit}>
          <Flex direction="column" gap={4}>
            <Box>
              <Text fontSize="sm" fontWeight="medium" mb={1}>
                {t('email')}
              </Text>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isPending}
                required
                autoComplete="email"
                data-testid="login-email"
              />
            </Box>

            <Box>
              <Text fontSize="sm" fontWeight="medium" mb={1}>
                {t('password')}
              </Text>
              <PasswordInput
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={isPending}
                required
                autoComplete="current-password"
                data-testid="login-password"
              />
            </Box>

            <Button
              type="submit"
              w="full"
              disabled={isPending}
              loading={isPending}
              data-testid="login-submit"
            >
              {t('submit')}
            </Button>

            {error && (
              <Alert.Root status="error">
                <Alert.Indicator />
                <Alert.Content>
                  <Alert.Title>{error}</Alert.Title>
                </Alert.Content>
              </Alert.Root>
            )}

            <Text textAlign="center" fontSize="sm">
              <Link to="/forgot-password">{t('forgotPassword')}</Link>
            </Text>
          </Flex>
        </form>
      </Box>
    </Flex>
  );
}

export default LoginScreen;
